module.exports = __webpack_public_path__ + "static/img/biotechnology_thumbnail.81b8bfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/biotechnology_thumbnail.jpg
// module id = 5OWL
// module chunks = 6